import { Box, Button, CircularProgress } from '@mui/material'
import PasswordInput from 'components/PasswordInput'
import React, { useMemo, useState } from 'react'
import utils from 'helpers/utils'
import { useLocation } from 'react-router-dom'
import axios from 'providers/axios'
import useShowError from 'hooks/useShowError'
import useSnackbarStore from 'hooks/useSnackbarStore'
import { URL_APP } from 'helpers/config'
import AuthTemplate from 'components/templates/AuthTemplate'

const ResetPassword: React.FC = () => {
  const showError = useShowError()
  const { openSnackbar } = useSnackbarStore()
  const location = useLocation()
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search])

  const [password, setPassword] = useState({ value: '', error: false })
  const [loading, setLoading] = useState(false)

  const isFormValid = useMemo(() => {
    const validPassword = !password.error
    return validPassword
  }, [password.error])

  const resetPassword = async () => {
    if (!password || password.error) return
    setLoading(true)
    try {
      await axios.post('/reset-password', {
        resetPasswordToken: searchParams.get('token'),
        authDevice: utils.getFullAuthDeviceData(),
        password: password.value,
      })
      openSnackbar('Password reset successfully! Redirecting... ', 'success')
      setTimeout(() => {
        window.location.href = URL_APP
      }, 2000)
    } catch (error) {
      showError(error)
      setLoading(false)
    }
  }

  return (
    <AuthTemplate>
      <Box mb="16px" maxWidth="400px" mx="auto">
        <h2 style={{ marginTop: 0, marginBottom: 32 }}>Reset password</h2>

        <PasswordInput
          label="New password"
          onChange={(state) => {
            setPassword({
              value: state.value,
              error: !state.isValid,
            })
          }}
        />

        <Button variant="contained" fullWidth disabled={!isFormValid || loading} onClick={resetPassword} sx={{ mt: '16px' }}>
          {loading ? <CircularProgress size="20px" /> : 'OK'}
        </Button>
      </Box>
    </AuthTemplate>
  )
}

export default ResetPassword
